module.exports = __webpack_public_path__ + "media/honey-icons/icon-colour-207608f1.svg";